import { useRef, useState } from 'react';
import { SUPABASE_URL, SUPABASE_ANON } from '../lib/firebase';

export function useVoiceRecorder() {
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const chunksRef        = useRef([]);
  const streamRef        = useRef(null);
  const startTimeRef     = useRef(null);

  async function startRecording(e) {
    if (e) e.preventDefault();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current    = stream;
      chunksRef.current    = [];
      startTimeRef.current = Date.now();
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = ev => { if (ev.data.size > 0) chunksRef.current.push(ev.data); };
      mr.start();
      mediaRecorderRef.current = mr;
      setRecording(true);
    } catch {
      alert('Microphone permission denied.');
    }
  }

  function stopRecording(onDone) {
    setRecording(false);
    const mr = mediaRecorderRef.current;
    if (!mr || mr.state === 'inactive') return;
    const duration = Math.round((Date.now() - startTimeRef.current) / 1000);
    if (duration < 1) { mr.stop(); streamRef.current?.getTracks().forEach(t => t.stop()); return; }
    mr.stop();
    streamRef.current?.getTracks().forEach(t => t.stop());
    mr.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: 'audio/webm' });
      onDone(blob, duration);
    };
  }

  return { recording, startRecording, stopRecording };
}

export async function uploadVoice(blob, uid) {
  const filename = `${uid}_${Date.now()}.webm`;
  const res = await fetch(`${SUPABASE_URL}/storage/v1/object/hangout/${filename}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${SUPABASE_ANON}`,
      'Content-Type': 'audio/webm',
      'x-upsert': 'true',
    },
    body: blob,
  });
  if (!res.ok) throw new Error('Upload failed: ' + await res.text());
  return `${SUPABASE_URL}/storage/v1/object/public/hangout/${filename}`;
}
